import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  getUserRoles(): string[] {
    try {
      const userData = localStorage.getItem('loggedUser');
      if (!userData) return [];
      const user = JSON.parse(userData);
      return Array.isArray(user.rol) ? user.rol : [];
    } catch {
      return [];
    }
  }

  isAdmin(allowedRoles: string[]): boolean {
    const userRoles = this.getUserRoles();
    return Array.isArray(userRoles) && allowedRoles.some(role => userRoles.includes(role));
  }

  getUser(): any {
    try {
      const userData = localStorage.getItem('loggedUser');
      if (!userData) return {};
      const user = JSON.parse(userData);
      return user;
    } catch {
      return {};
    }
  }
}
